import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Support} from "../../../../shared/interface/support";
import {Post} from "../../../../shared/interface/post";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {SupportService} from "../../../../shared/services/support.service";
import {AuthService} from "../../../../shared/services/auth.service";
import {first, takeUntil} from "rxjs/operators";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import {PostService} from "../../../../shared/services/post.service";
import {Dictionary} from "../../../../shared/interface/dictionary";
import {Regional} from "../../../../shared/interface/regional";
import {User} from "../../../../shared/interface/user";
import {DictService} from "../../../../shared/services/dict.service";
import {RegionalService} from "../../../../shared/services/regional.service";
import {PermissionsTag} from "../../../../shared/interface/permissions-tag";
import {PermissionTagsService} from "../../../../shared/services/permission-tags.service";
import {Attachments} from "../../../../shared/interface/attachments";
import {InsuranceCompany} from "../../../../shared/interface/insurance-company";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {InsuranceCompanyService} from "../../../../shared/services/insurance-company.service";
import {Profile} from "../../../../shared/interface/profile";
import {HttpErrorResponse} from "@angular/common/http";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../../shared/components/job-result-dialog/job-result-dialog.component";
import {Department} from "../../../../shared/interface/department";
import {DepartmentService} from "../../../../shared/services/department.service";
import {src} from "../../../../../environments/environment";

@Component({
  selector: 'app-post-details-view',
  templateUrl: './post-details-view.component.html',
  styleUrls: ['./post-details-view.component.scss']
})
export class PostDetailsViewComponent implements OnInit, OnDestroy {

  @Input() post: Observable<Post>;
  @Output() modifyClicked = new EventEmitter<any>();

  postObject?: Post;
  userPermissions: ReplaySubject<UserPermissions>;
  readonly src = src;

  permissionTagPartner: Dictionary[] = [];
  permissionContractType: Dictionary[] = [];
  permissionIddTrainingStatus: Dictionary[] = [];
  permissionRegional: Regional[] = [];
  permissionRegistration: InsuranceCompany[] = [];
  permissionTag: PermissionsTag[] = [];
  permissionDepartment: Department[] = [];
  haveLongAttachment = false;
  haveShortAttachment = false;
  haveAttachmentAttachment = false;
  profile: Profile;
  initialFilters: any;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private auth: AuthService,
    private postService: PostService,
    private dictService: DictService,
    private regionalsService: RegionalService,
    private privateTagsService: PermissionTagsService,
    private insuranceCompanyService: InsuranceCompanyService,
    private departmentService: DepartmentService,
  ) {
    this.userPermissions = auth.getUserPermissions();

  }

  ngOnInit(): void {
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
      });
    this.post
      .pipe(takeUntil(this.destroyed$))
      .subscribe((post: Post) => {
        this.postObject = post;
        this.postObject.postDetails.sort(  (a, b) => a.postDetailIndex - b.postDetailIndex );
        this.loadPermision(post);
        post.attachments.forEach((attachment: Attachments) => {
          if (attachment.type.key === 'short'){
            this.haveShortAttachment = true;
          }
          if (attachment.type.key === 'long'){
            this.haveLongAttachment = true;
          }
          if (attachment.type.key === 'attachment'){
            this.haveAttachmentAttachment = true;
          }
        });
      });
  }

  loadPermision(post: Post): void {
    this.permissionTagPartner = [];
    post.permissionTagPartner.forEach((dictId: number) => {
      this.dictService.getDict(dictId)
        .subscribe((dict: Dictionary) => {
          this.permissionTagPartner.push(dict);
        });
    });
    this.permissionContractType = [];
    post.permissionContractType.forEach((dictId: number) => {
      this.dictService.getDict(dictId)
        .subscribe((dict: Dictionary) => {
          this.permissionContractType.push(dict);
        });
    });
    this.permissionRegional = [];
    post.permissionRegional.forEach((uuid: string) => {
      this.regionalsService.getRegional(uuid)
        .pipe(first())
        .subscribe((regional: Regional) => {
          this.permissionRegional.push(regional);
        });
    });
    this.permissionIddTrainingStatus = [];
    post.permissionIddTrainingStatus.forEach((dictId: number) => {
      this.dictService.getDict(dictId)
        .subscribe((dict: Dictionary) => {
          this.permissionIddTrainingStatus.push(dict);
        });
    });
    this.permissionTag = [];
    post.permissionTag.forEach((tagId: number) => {
      this.privateTagsService.getDict(tagId)
        .subscribe((dict: PermissionsTag) => {
          this.permissionTag.push(dict);
        });
    });
    this.permissionRegistration = [];
    this.insuranceCompanyService.loadList(0, 1000, {});
    this.insuranceCompanyService.getInsuranceCompaniesPageSubject()
      .pipe(first())
      .subscribe((result: CountedAndPaginated<InsuranceCompany>) => {
        result.items.forEach((insuranceCompany: InsuranceCompany) => {
          if ( post.permissionRegistrationList.includes(insuranceCompany.id)) {
            this.permissionRegistration.push(insuranceCompany);
          }
        });

      });
    this.permissionDepartment = [];
    this.departmentService.loadList(0, 1000, {});
    this.departmentService.getDepartmentListSubject()
      .pipe(first())
      .subscribe((result: CountedAndPaginated<Department>) => {
        result.items.forEach((department: Department) => {
          if ( post.permissionDepartmentList.includes(department.uuid)) {
            this.permissionDepartment.push(department);
          }
        });

      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  copyPost(): void {
    this.postService.copy(this.postObject.uuid)
      .subscribe(() => {
        this.snack.open('Pomyślnie skopiowano post', '', {duration: 2000});
        this.router.navigate(['/asf360/aktualnosci']); }
        , (error: HttpErrorResponse) => {
        this.snack.open('Nie udało się skopiować_postu ', error.status.toString(), {
          duration: 2000
        });
      });
  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć post?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.postService.delete(this.postObject.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto post', '', {duration: 2000});
            this.router.navigate(['/asf360/aktualnosci']);
          });
      }
    });
  }

  deleteAttachment(attachment: Attachments): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć załącznik?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.postService.deleteAttachment(attachment.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto załącznik', '', {duration: 2000});
            window.location.reload();
          });
      }
    });
  }

  downloadAttachment(attachment: Attachments): void {
    this.postService.downloadAttachment(attachment.uuid);
  }
  downloadAttachmentFile(fileLocation: string, fileName: string): void {
    this.postService.downloadAttachmentFile(fileLocation, fileName);
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

      filters.uuid =  this.postObject.uuid;

    return filters;
  }

  downloadReport(): void {
    this.postService.downloadReportCta(this.buildFilters());
  }
}
